import React, {Component} from 'react';
import PrinterMap from './PrinterMap';
import { useSearchParams } from 'react-router-dom';

function withParams(Component) {
  // eslint-disable-next-line react/display-name
  return props => {
    const [searchParams] = useSearchParams();
    return <Component {...props} searchParams={searchParams} />;
  };
}

class PrinterMapWidget extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      language: 'en',
      printers: [],
    };

    this.getPrinter = this.getPrinter.bind(this);
  }

  render() {
    const filteredPrinters = this.props.filterName
      ? this.state.printers.filter(printer =>
          printer.name.toLowerCase().includes(this.props.filterName.toLowerCase())
        )
      : this.state.printers;

    // Read showPhoto and showDocument from GET parameters
    const showPhotoParam = this.props.searchParams?.get('showPhoto');
    const showDocumentParam = this.props.searchParams?.get('showDocument');

    // Convert string params to boolean, defaulting to true if not provided
    const showPhoto = showPhotoParam !== null ? showPhotoParam === 'true' : true;
    const showDocument = showDocumentParam !== null ? showDocumentParam === 'true' : true;

    return (
      <PrinterMap
        printers={filteredPrinters}
        clusterImage={this.props.clusterImage}
        apiKey={process.env.REACT_APP_GMAPS_EMBED_API_KEY}
        loading={this.state.loading}
        openInNewTab={true}
        showPhoto={showPhoto}
        showDocument={showDocument}
      />
    )
  }

  getPrinter() {
    return fetch(this.apiUrl('/printers')).then(function(response) {
      return response.json();
    }).then((json) => {
      this.setState({printers: json, loading: false});
    }).catch(function(ex) {
      console.log('parsing failed', ex);
    });
  }

  apiUrl(path) {
    return process.env.REACT_APP_API_HOST + process.env.REACT_APP_API_PREFIX + path;
  }

  componentDidMount() {
    this.getPrinter();
  }
}

export default withParams(PrinterMapWidget);
